import jui from "juijs"

export default {
    name: "chart.brush.map.core",
    extend: "chart.brush.core",
    component: function () {
        var MapCoreBrush = function() {
        }

        return MapCoreBrush;
    }
}